import React from 'react'

import DynamicMap from './dynamicMap.component';
import SidebarMaps from './sidebar.component';

import PanMap from './panMap.component';


/*eslint-disable */
interface Props{
    isLocation: boolean,
    locationData: any,
    colorsData: any,
    handleMenuSelection: any
}

interface State{
    filteredRoute: any,
    selectedPOI: any,
    routesActive: boolean,
    POISActive: boolean,
    activeIllustratedMap: boolean,
    image: string
}

class MapContainer extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            filteredRoute: "",
            selectedPOI: {},
            routesActive: true,
            POISActive: false,
            activeIllustratedMap: false,
            image: ''
        }
    }

    componentDidMount(): void {
        if(this.props.locationData.mapa_ilustrado_pois){
            new Promise((resolve, reject) => {
                var img = new Image()
                img.src = 'https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/'+this.props.locationData.mapa_ilustrado_pois
            })
        }
        if(this.props.locationData.mapa_ilustrado_vias){
            new Promise((resolve, reject) => {
                var img = new Image()
                img.src = 'https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/'+this.props.locationData.mapa_ilustrado_vias
            })
            //this.setState({image: this.props.locationData?.mapa_ilustrado_vias})
        }
    }

    handleFilteredRoute = (route: string) => {
        this.setState({
            filteredRoute: route,
            routesActive: true,
            POISActive: false
        })
    }

    handleSelectPOI = (poi: any) => {
        console.log(poi);
        
        this.setState({
            selectedPOI: poi,
            routesActive: false,
            POISActive: true
        })
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if(this.props.isLocation !== prevProps.isLocation && this.props.isLocation){
            this.setState({
                POISActive: false,
                selectedPOI: '',
                routesActive: true,
                filteredRoute: ''
            })
        }
        if(prevProps.locationData !== this.props.locationData){
            if(this.props.locationData.mapa_ilustrado_pois){
                var img = new Image
                img.src = 'https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/'+this.props.locationData.mapa_ilustrado_pois
            }
            if(this.props.locationData.mapa_ilustrado_vias){
                var img = new Image
                img.src = 'https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/'+this.props.locationData.mapa_ilustrado_vias
                //this.setState({image: this.props.locationData?.mapa_ilustrado_vias})
            }
        }
    }

    handleChangeToMapaIlustrado = (active: boolean, image: any) => {
        this.setState({
            activeIllustratedMap: active,
            image: image
        })
    }

    render(): React.ReactNode {
        //console.log(this.state.image);
        
        return(
            <div className={this.props.isLocation ? 'map-container-main fade-in':'map-container-main fade-out'}>
                {
                    this.props.locationData ?
                    <DynamicMap
                        locationData={this.props.locationData}
                        filteredRoute = {this.state.filteredRoute}
                        selectedPOI = {this.state.selectedPOI}
                        colorsData={this.props.colorsData}
                        routesActive = {this.state.routesActive}
                        POISActive = {this.state.POISActive}
                        isLocation = {this.props.isLocation}
                    />:null
                }
                {this.props.isLocation ?
                    <PanMap
                        activeIllustratedMap = {this.state.activeIllustratedMap}
                        image = {this.state.image}
                    />:null
                }
                {   
                    this.props.locationData && this.props.isLocation?
                    <SidebarMaps
                        locationData={this.props.locationData}
                        colorsData = {this.props.colorsData}
                        handleFilteredRoute = {this.handleFilteredRoute}
                        handleSelectPOI = {this.handleSelectPOI}
                        handleMenuSelection = {this.props.handleMenuSelection}
                        routesActive = {this.state.routesActive}
                        POISActive = {this.state.POISActive}
                        isLocation={this.props.isLocation}
                        handleChangeToMapaIlustrado = {this.handleChangeToMapaIlustrado}
                        activeIllustratedMap = {this.state.activeIllustratedMap}
                    />:null
                }
            </div>
        )
    }
} 

export default MapContainer